import { render, staticRenderFns } from "./storageSupplyItems.vue?vue&type=template&id=9d8be54e&scoped=true&"
import script from "./storageSupplyItems.vue?vue&type=script&lang=js&"
export * from "./storageSupplyItems.vue?vue&type=script&lang=js&"
import style0 from "./storageSupplyItems.vue?vue&type=style&index=0&id=9d8be54e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d8be54e",
  null
  
)

export default component.exports